import { DatePicker } from "@mui/x-date-pickers";
import { useToastContext } from "components/alert/ToastContext";
import { Label } from "components/input/Label";
import dayjs from "dayjs";
import Usuario from "model/administracao/cadastro/Usuario";
import DocumentoSolicitacaoRevisao from "model/documentos/DocumentoSolicitacaoRevisao";
import RespostaSolicitacao from "model/documentos/RespostaSolicitacao";
import { AutoComplete } from "primereact/autocomplete";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputTextarea } from "primereact/inputtextarea";
import { useLoadingContext } from "provider/LoadingProvider";
import { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import DocumentoSolicitacaoRevisaoService from "service/documentos/DocumentoSolicitacaoRevisaoService";
import { usuarioCompleteMethod, usuarioItemTemplate } from "utils/autocompleteUtils";
import { converterDataHora } from "utils/convert";

type Props = {
    visible: boolean;
    onHide: () => void;
    solicitacao: DocumentoSolicitacaoRevisao;
    onConfirm: () => void;
}

const service = new DocumentoSolicitacaoRevisaoService();
export default function ModalDocumentoResponderSolicitacaoRevisao(props: Props) {

    const [dados, setDados] = useState<RespostaSolicitacao>(new RespostaSolicitacao(props.solicitacao.id, "", "", props.solicitacao.documento?.categoria.aprovadorPadrao, null, props.solicitacao.documento?.categoria.revisorPadrao));
    const { control, setFocus, clearErrors, setError, formState: { errors } } = useForm();
    const [usuarios, setUsuarios] = useState<Usuario[]>([]);
    const [usuariosFiltrados, setUsuariosFiltrados] = useState<Usuario[]>([]);

    const { startLoading, stopLoading } = useLoadingContext();
    const { msgErro, msgAlerta } = useToastContext();

    function handleConfirm(aceitou: boolean) {
        if (!validar(aceitou)) {
            return;
        }
        let dadosLocal = dados;
        dadosLocal.resposta = aceitou ? "ACEITA" : "REJEITADA";
        startLoading();
        service.responder(dados).then(() => {
            stopLoading();
            props.onConfirm();
            props.onHide();
        }).catch((error) => {
            stopLoading();
            msgErro("Erro ao solicitar revisão", error?.data?.message || "");
            console.error("Erro ao solicitar revisão:", error);
        });

    }

    function validar(aceitou: boolean) {
        if (aceitou) {
            if (!dados.responsavelRevisao) {
                setError("responsavelRevisao", { type: "manual", message: "Responsável Revisão é Obrigatório ao aceitar a solicitação" }, { shouldFocus: true })
                return false;
            }
            if (!dados.prazoRevisao) {
                setError("prazoRevisao", { type: "manual", message: "Prazo para revisão é Obrigatório ao aceitar a solicitação" }, { shouldFocus: true })
                return false;
            }
            if (props.solicitacao.documento?.categoria.temAprovacao) {
                if (!dados.responsavelAprovacao) {
                    setError("responsavelAprovacao", { type: "manual", message: "Responsável Aprovação é Obrigatório ao aceitar a solicitação" }, { shouldFocus: true })
                    return false;
                }
                if (!dados.prazoAprovacao) {
                    setError("prazoAprovacao", { type: "manual", message: "Prazo para aprovação é Obrigatório ao aceitar a solicitação" }, { shouldFocus: true })
                    return false;
                }
            }
        }

        return true;
    }

    useEffect(() => {
        service.usuarios().then((json) => {
            setUsuarios(json);
        }).catch((error) => {
            console.error("Erro ao buscar usuários:", error);
        });
    }, [])

    return (
        <Dialog
            header="Solicitar Revisão"
            visible={props.visible}
            baseZIndex={100}
            style={{ width: '500px' }}
            onHide={props.onHide}
            footer={<>
                <Button label="Rejeitar" icon="pi pi-times" className="p-button-danger" onClick={() => handleConfirm(false)} />
                <Button label="Aceitar" icon="pi pi-check" onClick={() => handleConfirm(true)} />
            </>}
        >
            <span style={{ fontWeight: 700 }}>Solicitação</span>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem', marginBottom: '1rem', paddingLeft: '12px', paddingRight: '12px' }}>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '0.2rem' }}>
                    <Label>Usuário</Label>
                    <span>{props.solicitacao.usuarioSolicitacao?.nome || ""}</span>
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '0.2rem' }}>
                    <Label>Data</Label>
                    <span>{converterDataHora(props.solicitacao.dataGeracao)}</span>
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '0.2rem' }}>
                    <Label>Descrição</Label>
                    <span>{props.solicitacao.descricao}</span>
                </div>
            </div>
            <div style={{ borderTop: '1px solid #ccc', marginTop: '1rem', paddingTop: '1rem' }}>
                <span style={{ fontWeight: 700 }}>Resposta</span>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem', paddingLeft: '12px', paddingRight: '12px' }}>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '0.2rem' }}>
                        <Label>Motivo</Label>
                        <InputTextarea rows={3} value={dados.observacaoResposta || ""} onChange={(e) => {
                            setDados({ ...dados, observacaoResposta: e.target.value });
                        }} style={{ width: '100%' }} />
                    </div>

                    <div style={{ display: 'flex', flexDirection: 'row', columnGap: 12, marginBottom: '1rem' }}>
                        <div className="col-md-6">
                            <Label obrigatorio>Responsável Revisão</Label>
                            <Controller name="responsavelRevisao" control={control} render={({ field }) => (
                                <AutoComplete
                                    inputRef={field.ref}
                                    dropdown
                                    value={dados.responsavelRevisao}
                                    placeholder="Selecione um usuário"
                                    style={{ width: '100%' }}
                                    className={errors.responsavelRevisao ? "p-invalid" : ""}
                                    field="nome"
                                    itemTemplate={(item: Usuario) => usuarioItemTemplate(item)}
                                    suggestions={usuariosFiltrados}
                                    completeMethod={(e) => {
                                        let filtered: Usuario[] = usuarioCompleteMethod(usuarios, e.query);
                                        setUsuariosFiltrados(filtered);
                                    }}
                                    onChange={(e) => {
                                        let finalizarElaboracaoLocal = JSON.parse(JSON.stringify(dados));

                                        if (!e.target.value) {
                                            finalizarElaboracaoLocal.responsavelRevisao = null;
                                        } else if (typeof e.target.value == "string") {
                                            let usuario = new Usuario();
                                            usuario.nome = e.target.value;
                                            finalizarElaboracaoLocal.responsavelRevisao = usuario;
                                        } else {
                                            finalizarElaboracaoLocal.responsavelRevisao = e.target.value;
                                        }
                                        clearErrors("responsavelRevisao");
                                        setDados(finalizarElaboracaoLocal);
                                    }}
                                />
                            )} />
                            {errors.responsavelRevisao && errors.responsavelRevisao.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.responsavelRevisao?.message as string}</span> : null}
                        </div>

                        <div className="col-md-6 ">
                            <Label>Prazo para Revisão</Label>
                            <Controller name="prazoRevisao" control={control} render={({ field }) => (
                                <DatePicker
                                    slotProps={{
                                        popper: {
                                            disablePortal: true,
                                        },
                                    }}
                                    inputRef={field.ref}
                                    value={dayjs(dados.prazoRevisao)}
                                    onChange={value => {
                                        clearErrors("prazoRevisao")
                                        setDados({ ...dados, prazoRevisao: value?.startOf("day").toDate() || null })
                                    }}
                                />
                            )} />
                            {errors.prazoRevisao && errors.prazoRevisao.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.prazoRevisao?.message as string}</span> : null}
                        </div>
                    </div>
                    {props.solicitacao.documento?.categoria.temAprovacao ? <>
                        <div style={{ display: 'flex', flexDirection: 'row', columnGap: 12, marginBottom: '1rem' }}>
                            <div className="col col-sm-6">
                                <Label className="col col-sm-12" obrigatorio>Responsável Aprovação</Label>
                                <Controller name="responsavelAprovacao" control={control} render={({ field }) => (
                                    <AutoComplete
                                        inputRef={field.ref}
                                        dropdown
                                        value={dados.responsavelAprovacao}
                                        placeholder="Selecione um usuário"
                                        style={{ width: '100%' }}
                                        className={errors.responsavelAprovacao ? "p-invalid" : ""}
                                        field="nome"
                                        itemTemplate={(item: Usuario) => usuarioItemTemplate(item)}
                                        suggestions={usuariosFiltrados}
                                        completeMethod={(e) => {
                                            let filtered: Usuario[] = usuarioCompleteMethod(usuarios, e.query);
                                            setUsuariosFiltrados(filtered);
                                        }}
                                        onChange={(e) => {
                                            let finalizarElaboracaoLocal = JSON.parse(JSON.stringify(dados));

                                            if (!e.target.value) {
                                                finalizarElaboracaoLocal.responsavelAprovacao = null;
                                            } else if (typeof e.target.value == "string") {
                                                let usuario = new Usuario();
                                                usuario.nome = e.target.value;
                                                finalizarElaboracaoLocal.responsavelAprovacao = usuario;
                                            } else {
                                                finalizarElaboracaoLocal.responsavelAprovacao = e.target.value;
                                            }
                                            clearErrors("responsavelAprovacao")
                                            setDados(finalizarElaboracaoLocal);
                                        }}
                                    />
                                )} />
                                {errors.responsavelAprovacao && errors.responsavelAprovacao.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.responsavelAprovacao?.message as string}</span> : null}
                            </div>
                            <div className="col-md-6">
                                <Label>Prazo para Aprovação</Label>
                                <Controller name="prazoAprovacao" control={control} render={({ field }) => (
                                    <DatePicker
                                        slotProps={{
                                            popper: {
                                                disablePortal: true,
                                            },
                                        }}
                                        inputRef={field.ref}
                                        value={dayjs(dados.prazoAprovacao)}
                                        onChange={value => {
                                            clearErrors("prazoAprovacao")
                                            setDados({ ...dados, prazoAprovacao: value?.startOf("day").toDate() || null })
                                        }}
                                    />
                                )} />
                                {errors.prazoAprovacao && errors.prazoAprovacao.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.prazoAprovacao?.message as string}</span> : null}
                            </div>
                        </div>
                    </> : null}
                </div>
            </div>
        </Dialog >
    );
}